import { getDb } from './schema.ts';

/**
 * Tiny KV-style accessor for app preferences. Values are stored as JSON-safe
 * data. Strongly-typed callers can wrap these for specific keys (e.g. a
 * `getReaderPrefs()` helper in the reader feature).
 */

export async function getPref<T = unknown>(key: string): Promise<T | undefined> {
  const db = await getDb();
  const row = await db.get('prefs', key);
  return row?.value as T | undefined;
}

export async function setPref(key: string, value: unknown): Promise<void> {
  const db = await getDb();
  await db.put('prefs', { key, value });
}

export async function deletePref(key: string): Promise<void> {
  const db = await getDb();
  await db.delete('prefs', key);
}

export const PREF_KEYS = {
  THEME: 'theme',
  READER_MODE: 'reader.mode',
  PRELOAD_COUNT: 'reader.preloadCount',
  PROXY_BASE: 'proxy.base',
} as const;
